import {
  IMAGE_URL_POLICY,
  sanitizeWorkflowHtmlForDisplay,
  sanitizeWorkflowHtmlForPersist,
  sanitizeWorkflowUrlForDisplay,
  sanitizeWorkflowUrlForPersist,
} from './sanitizeWorkflowHtml';

export const SANITIZE_MODE = IMAGE_URL_POLICY;

export function sanitizeStepContent({ text, graphic } = {}, mode = SANITIZE_MODE.PERSIST) {
  const isDisplay = mode === SANITIZE_MODE.DISPLAY;
  const sanitizeHtml = isDisplay ? sanitizeWorkflowHtmlForDisplay : sanitizeWorkflowHtmlForPersist;
  const sanitizeUrl = isDisplay ? sanitizeWorkflowUrlForDisplay : sanitizeWorkflowUrlForPersist;

  const result = {};
  if (text !== undefined) {
    result.text = typeof text === 'string' ? sanitizeHtml(text) : text;
  }
  if (graphic !== undefined) {
    result.graphic = typeof graphic === 'string' ? sanitizeUrl(graphic) : graphic;
  }
  return result;
}
